import React from 'react';
import coeur from 'assets/images/coeur.png';
import styles from './heart-container-component.module.css';

export const HeartContainer: React.FC<{
    children: React.ReactNode;
    // eslint-disable-next-line react/require-default-props
    containerClass?: string;
    // eslint-disable-next-line react/require-default-props
    textAlign?: 'left' | 'center' | 'right';
}> = ({ children, containerClass, textAlign = 'center' }) => {
    return (
        <div className={`${styles.newsLetterForm} ${containerClass}`}>
            <img className={styles.newsLetterHeart} alt="logo jusqu'au jour j" src={coeur} />
            <div className={styles.nlInnerForm} style={{ textAlign }}>
                {children}
            </div>
        </div>
    );
};
